export default class mainlandfreightdetail {
    id: number;
    warehouseInfoId: number;
    warehouseName: string;
    site: number;
    cargoCategory: number;
    beginTime?: Date;
    endTime?: Date;
    isEffective: boolean;
    firstWeight: number;
    firstWeightPrice : number;
    continueWeight: number;
    continueWeightCost: number;
    bulkyParameter: number;
}